module.exports = "<div ng-if=\"hideLoadMore!==true\" class=pointable style=text-align:center;padding:4px ng-click=loadMore()> <i class=\"fa fa-arrow-circle-o-down\" aria-hidden=true></i> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableLoadMore.html
// module id = 369
// module chunks = 0